import React, { useState } from 'react';
import { projects } from '../../data/constants';
import useReveal from '../../hooks/useReveal';
import './styles.css';

const FILTERS = [
  { label: 'All', value: 'all' },
  { label: 'Full Stack', value: 'fullstack' },
  { label: 'AI / ML', value: 'ai' },
];

export default function Projects({ onOpenProject }) {
  const [filter, setFilter] = useState('all');
  const ref = useReveal();

  const filtered = filter === 'all' ? projects : projects.filter(p => p.category === filter);
  const featured = projects.filter(p => p.featured);

  return (
    <section className="section" id="projects" ref={ref}>
      <p className="section-label reveal">Projects</p>
      <h2 className="section-title reveal reveal-delay-1">Things I've Built</h2>
      <p className="section-subtitle reveal reveal-delay-2">
        A selection of projects spanning full-stack apps, AI/ML, and generative AI.
      </p>

      {/* Featured showcase */}
      <div className="proj__featured reveal reveal-delay-3">
        {featured.map((p) => (
          <div className="proj__feat-card" key={p.id} onClick={() => onOpenProject(p)}>
            <div className="proj__feat-img-wrap">
              <img src={p.image} alt={p.title} className="proj__feat-img" />
              <div className="proj__feat-overlay">
                <span className="proj__feat-view">View Details &rarr;</span>
              </div>
            </div>
            <div className="proj__feat-content">
              <div className="proj__feat-tags">
                {p.tags.slice(0, 4).map((t, i) => (
                  <span className="proj__tag" key={i}>{t}</span>
                ))}
              </div>
              <h3 className="proj__feat-title">{p.title}</h3>
              <p className="proj__feat-tagline">{p.tagline}</p>
              <span className="proj__feat-date">{p.date}</span>
            </div>
          </div>
        ))}
      </div>

      {/* Filter bar */}
      <div className="proj__filters reveal">
        {FILTERS.map((f) => (
          <button
            key={f.value}
            className={`proj__filter ${filter === f.value ? 'proj__filter--active' : ''}`}
            onClick={() => setFilter(f.value)}
          >
            {f.label}
          </button>
        ))}
      </div>

      {/* Grid */}
      <div className="proj__grid reveal">
        {filtered.map((p) => (
          <div className="proj__card" key={p.id} onClick={() => onOpenProject(p)}>
            {p.image && (
              <div className="proj__card-img-wrap">
                <img src={p.image} alt={p.title} className="proj__card-img" />
              </div>
            )}
            <div className="proj__card-body">
              <div className="proj__card-tags">
                {p.tags.slice(0, 3).map((t, i) => (
                  <span className="proj__tag proj__tag--sm" key={i}>{t}</span>
                ))}
              </div>
              <h3 className="proj__card-title">{p.title}</h3>
              <p className="proj__card-tagline">{p.tagline}</p>
              <span className="proj__card-date">{p.date}</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
